/* ==========================================================================
   ab2026-09 — cajón de tallas en la compra rápida móvil (test A/B)

   Control: el «+» de la tarjeta abre la barra de chips y tocar una talla añade
   directo (assets/pcard-sizes.js). Variante: el «+» abre un cajón lateral con
   las tallas en tabla y un CTA que confirma. Tras añadir, igual que hoy: se
   cierra el cajón y se abre el carrito.

   Solo en modo táctil ((max-width: 767px), (hover: none), (pointer: coarse)).
   Fuera: recomendados de la PDP (.section-main-product) y landings.

   Los datos del cajón se COPIAN de los chips de la propia tarjeta (texto,
   variant id, disabled, data-ab2026-09-last): no se pide /products/x.js.

   La DECISIÓN se toma al tocar el «+» (exposición donde divergen), en los dos
   brazos: el snippet ab2026-09-cajon-tallas.liquid deja aquí un `decisor`
   (GrowthBook) o fija el estado por override/cache. Si no hay decisor ni
   estado, control: este fichero no intercepta nada.

   Eventos propios a GA4 (si existe window.__lejEnviarGa4, de lej-growthbook):
   `quick_add_open` al abrir (chips o cajón) y `quick_add_add` al añadir, con
   ep.variant = control | variante y ep.experiment_id = ab2026-09. Sirven para
   leer «abrió y no añadió» por brazo, que la métrica de compra no enseña.

   Cierre del test: borrar este fichero. `grep -ri "ab2026[-_]09"` a cero.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__ab2026_09Init) return;
  window.__ab2026_09Init = true;

  var CLAVE = 'ab2026-09';
  var TACTIL = window.matchMedia('(max-width: 767px), (hover: none), (pointer: coarse)');
  var SIN_MOVIMIENTO = window.matchMedia('(prefers-reduced-motion: reduce)');
  var estado = null;          /* null = sin decidir · true = variante · false = control */
  var decisor = null;         /* function () -> boolean, lo deja el snippet cuando GB está listo */
  var veil, drawer, titulo, lista, cta, error, cerrar, unidades;
  var origen = null;          /* el «+» que abrió el cajón, para devolverle el foco */
  var elegida = null;         /* fila elegida */
  var scrollY = 0;            /* posición de la página al abrir (bloqueo de scroll iOS) */
  var textos = (window.theme && theme.ab2026_09) || {};
  var unidad = 'EU';

  function guardarCache(v) { try { localStorage.setItem(CLAVE, String(v)); } catch (e) {} }

  function evento(nombre, extra) {
    if (typeof window.__lejEnviarGa4 !== 'function') return;
    var params = { 'ep.experiment_id': CLAVE, 'ep.variant': estado ? 'variante' : 'control' };
    if (extra) for (var k in extra) params[k] = extra[k];
    try { window.__lejEnviarGa4(nombre, params); } catch (e) {}
  }

  /* ── Construcción (una vez, al primer uso) ─────────────────────────────── */

  function construir() {
    if (drawer) return;
    veil = document.createElement('div');
    veil.className = 'ab2026-09-veil';
    veil.setAttribute('aria-hidden', 'true');

    drawer = document.createElement('div');
    drawer.className = 'ab2026-09-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('aria-label', textos.selectSize || 'Selecciona una talla');
    drawer.innerHTML =
      '<div class="ab2026-09-drawer__head">' +
        '<p class="ab2026-09-drawer__title"></p>' +
        '<div class="ab2026-09-drawer__units" role="group" aria-label="EU / GB / US">' +
          '<button type="button" class="ab2026-09-drawer__unit" data-unit="EU" aria-pressed="true">EU</button>' +
          '<button type="button" class="ab2026-09-drawer__unit" data-unit="GB" aria-pressed="false">GB</button>' +
          '<button type="button" class="ab2026-09-drawer__unit" data-unit="US" aria-pressed="false">US</button>' +
        '</div>' +
        '<button type="button" class="ab2026-09-drawer__close">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="10.5" height="10.5" viewBox="0 0 10.5 10.5" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true" focusable="false"><path d="M0 0L10.5 10.5M10.5 0L0 10.5"></path></svg>' +
        '</button>' +
      '</div>' +
      '<div class="ab2026-09-drawer__body"><ul class="ab2026-09-table" role="listbox"></ul></div>' +
      '<div class="ab2026-09-drawer__foot">' +
        '<p class="ab2026-09-error" role="alert" hidden></p>' +
        '<button type="button" class="ab2026-09-cta" aria-live="polite"></button>' +
      '</div>';

    document.body.appendChild(veil);
    document.body.appendChild(drawer);

    titulo = drawer.querySelector('.ab2026-09-drawer__title');
    lista = drawer.querySelector('.ab2026-09-table');
    cta = drawer.querySelector('.ab2026-09-cta');
    error = drawer.querySelector('.ab2026-09-error');
    cerrar = drawer.querySelector('.ab2026-09-drawer__close');
    unidades = drawer.querySelector('.ab2026-09-drawer__units');

    titulo.textContent = textos.selectSize || 'Selecciona una talla';
    cerrar.setAttribute('aria-label', textos.close || 'Cerrar');

    veil.addEventListener('click', cerrarCajon);
    cerrar.addEventListener('click', cerrarCajon);
    cta.addEventListener('click', confirmar);
    unidades.addEventListener('click', function (e) {
      var b = e.target.closest('.ab2026-09-drawer__unit');
      if (!b) return;
      unidad = b.dataset.unit;
      guardarSistema(unidad);
      unidades.querySelectorAll('.ab2026-09-drawer__unit').forEach(function (u) {
        u.setAttribute('aria-pressed', u === b ? 'true' : 'false');
      });
      repintarEtiquetas();
    });
    lista.addEventListener('click', function (e) {
      var fila = e.target.closest('.ab2026-09-row');
      if (!fila || fila.disabled) return;
      elegir(fila);
    });
    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') { cerrarCajon(); return; }
      if (e.key === 'Tab') atraparFoco(e);
    });
    /* Deslizar a la derecha cierra. */
    var x0 = null;
    drawer.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    drawer.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (dx > 70) cerrarCajon();
    }, { passive: true });
  }

  /* Conversión EU → GB/US: la misma tabla que assets/variant-picker.js (que solo
     se carga en la ficha, por eso va copiada). Kids 21-35 con sufijo «K» en US,
     adulto 40-42 con W/M. Si cambia la de la ficha, cambiar esta. El sistema
     elegido se comparte con la ficha vía localStorage['sizeSystem'] (EU|UK|US). */
  var CONV = {
    '21': { UK: '4', US: '5.5' }, '22': { UK: '5', US: '6' }, '23': { UK: '6', US: '7' }, '24': { UK: '7', US: '8' },
    '25': { UK: '7.5', US: '8.5' }, '26': { UK: '8.5', US: '9.5' }, '27': { UK: '9', US: '10' }, '28': { UK: '10', US: '11' },
    '29': { UK: '11', US: '12' }, '30': { UK: '11.5', US: '12.5' }, '31': { UK: '12.5', US: '13.5' }, '32': { UK: '13.5', US: '1Y' },
    '33': { UK: '1', US: '1.5Y' }, '34': { UK: '2', US: '2.5Y' }, '35': { UK: '2.5', US: '3Y' },
    '36': { UK: '3', US: '5.5' }, '37': { UK: '4', US: '6' }, '38': { UK: '5', US: '7' }, '39': { UK: '6', US: '8' },
    '40': { UK: '7W / 6M', US: '8.5W / 7M' }, '41': { UK: '8W / 7M', US: '9.5W / 8M' }, '42': { UK: '9W / 8M', US: '10W / 8.5M' },
    '43': { UK: '9', US: '9.5' }, '44': { UK: '10', US: '10' }, '45': { UK: '11', US: '11' }, '46': { UK: '12', US: '12' }
  };
  var SISTEMA = { EU: 'EU', GB: 'UK', US: 'US' };

  function etiqueta(eu) {
    var sys = SISTEMA[unidad] || 'EU';
    if (sys === 'EU') return eu;
    var fila = CONV[String(eu).trim()];
    if (!fila || !fila[sys]) return eu;
    var v = fila[sys];
    /* Kids en US: sufijo K (nunca doblado, y sustituye a la Y antigua), como en la ficha. */
    if (sys === 'US' && parseFloat(eu) <= 35) v = String(v).replace(/\s*[YK]$/i, '') + 'K';
    return v;
  }

  function leerSistema() {
    try {
      var s = localStorage.getItem('sizeSystem');
      if (s === 'UK') return 'GB';
      if (s === 'US') return 'US';
    } catch (e) {}
    return 'EU';
  }

  function guardarSistema(u) {
    try { localStorage.setItem('sizeSystem', SISTEMA[u] || 'EU'); } catch (e) {}
  }

  function repintarEtiquetas() {
    lista.querySelectorAll('.ab2026-09-row').forEach(function (fila) {
      fila.querySelector('.ab2026-09-row__size').textContent = etiqueta(fila.dataset.size);
    });
  }

  function atraparFoco(e) {
    var focos = drawer.querySelectorAll('button:not([disabled])');
    if (!focos.length) return;
    var primero = focos[0], ultimo = focos[focos.length - 1];
    if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
  }

  function pintarCta() {
    cta.textContent = elegida ? (textos.addToCart || 'Añadir a la cesta') : (textos.selectSize || 'Selecciona una talla');
    cta.setAttribute('aria-disabled', elegida ? 'false' : 'true');
  }

  function elegir(fila) {
    if (elegida && elegida !== fila) elegida.setAttribute('aria-pressed', 'false');
    elegida = fila;
    fila.setAttribute('aria-pressed', 'true');
    pintarCta();
  }

  /* ── Abrir y cerrar ────────────────────────────────────────────────────── */

  function bloquearScroll() {
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.classList.add('ab2026-09-open');
    document.body.style.top = (-scrollY) + 'px';
  }

  function liberarScroll() {
    document.body.classList.remove('ab2026-09-open');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }

  function abrirCajon(block, btn) {
    construir();
    var chips = block.querySelectorAll('.pcard-size');
    if (!chips.length) return false;
    lista.innerHTML = '';
    elegida = null;
    error.hidden = true;
    unidad = leerSistema();
    unidades.querySelectorAll('.ab2026-09-drawer__unit').forEach(function (u) {
      u.setAttribute('aria-pressed', u.dataset.unit === unidad ? 'true' : 'false');
    });
    chips.forEach(function (chip) {
      var fila = document.createElement('button');
      fila.type = 'button';
      fila.className = 'ab2026-09-row';
      fila.setAttribute('role', 'option');
      fila.setAttribute('aria-pressed', 'false');
      fila.dataset.size = chip.textContent.trim();
      fila.dataset.variantId = chip.dataset.variantId || '';
      var size = document.createElement('span');
      size.className = 'ab2026-09-row__size';
      size.textContent = etiqueta(fila.dataset.size);
      fila.appendChild(size);
      var nota = '';
      if (chip.disabled) { fila.disabled = true; nota = textos.soldOut || 'Agotado'; }
      else if (chip.hasAttribute('data-ab2026-09-last')) { nota = textos.lastUnits || 'Últimas unidades'; }
      if (nota) {
        var n = document.createElement('span');
        n.className = 'ab2026-09-row__note';
        n.textContent = nota;
        fila.appendChild(n);
      }
      lista.appendChild(fila);
    });
    pintarCta();
    origen = btn;
    bloquearScroll();
    veil.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    veil.setAttribute('aria-hidden', 'false');
    lista.scrollTop = 0;
    setTimeout(function () { cerrar.focus({ preventScroll: true }); }, SIN_MOVIMIENTO.matches ? 0 : 310);
    return true;
  }

  function cerrarCajon() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    veil.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    veil.setAttribute('aria-hidden', 'true');
    liberarScroll();
    if (origen) { try { origen.focus({ preventScroll: true }); } catch (e) {} }
    origen = null;
  }

  /* ── Carrito: misma llamada que pcard-sizes.js ─────────────────────────── */

  function addToCart(variantId) {
    var sectionsToUpdate = ['page-header', 'cart-drawer']
      .map(function (sel) { return document.querySelector(sel); })
      .filter(function (el) { return el; });
    var sectionIds = sectionsToUpdate.map(function (el) { return el.dataset.sectionId; }).filter(Boolean);
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    if (sectionIds.length) fd.append('sections', sectionIds.join(','));
    fd.append('sections_url', window.location.pathname);
    var addUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    return fetch(addUrl, {
      method: 'POST', credentials: 'same-origin',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (res) {
      if (!res.ok) {
        /* El 422 de add.js trae `description` ya localizada por Shopify. */
        return res.json().catch(function () { return {}; }).then(function (err) {
          throw new Error((err && (err.description || err.message)) || (window.theme && theme.strings && theme.strings.noStock) || '');
        });
      }
      return res.json();
    }).then(function (data) {
      if (data.sections && sectionsToUpdate.length) {
        sectionsToUpdate.forEach(function (el) {
          var sid = el.dataset.sectionId;
          if (sid && data.sections[sid] && typeof el.updateFromCartChange === 'function') el.updateFromCartChange(data.sections[sid]);
        });
      } else {
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      }
      return data;
    });
  }

  function confirmar() {
    /* Sin talla: nada visible; el CTA lleva aria-live y su texto ya lo dice. */
    if (!elegida) return;
    if (cta.classList.contains('is-loading')) return;
    var id = elegida.dataset.variantId;
    if (!id) return;
    cta.classList.add('is-loading');
    cta.setAttribute('aria-busy', 'true');
    error.hidden = true;
    var talla = elegida.dataset.size;
    addToCart(id).then(function () {
      cta.classList.remove('is-loading');
      cta.removeAttribute('aria-busy');
      evento('quick_add_add', { 'ep.size': talla });
      cerrarCajon();
      var cart = document.querySelector('cart-drawer');
      if (!(cart && cart.hasAttribute('open'))) {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: null } }));
      }
    }).catch(function (err) {
      cta.classList.remove('is-loading');
      cta.removeAttribute('aria-busy');
      error.textContent = (err && err.message) || '';
      error.hidden = !error.textContent;
    });
  }

  /* ── El «+»: decidir y, si toca, interceptar ───────────────────────────── */

  function decidir() {
    if (typeof decisor !== 'function') return;
    var v;
    try { v = decisor() === true; } catch (e) { return; }
    estado = v;
    guardarCache(v);
  }

  /* Captura: va ANTES que el listener de pcard-sizes.js (burbuja en document).
     Solo tarjetas fuera de la PDP y de páginas, y solo en táctil. */
  document.addEventListener('click', function (e) {
    if (!TACTIL.matches || !e.target.closest) return;
    var btn = e.target.closest('.product-block .mobile-add-button');
    if (!btn) return;
    var block = btn.closest('.product-block');
    if (!block || block.classList.contains('product-block--comingsoon')) return;
    if (block.closest('.section-main-product, .template-page, .template-article')) return;

    /* La exposición se emite aquí, en los dos brazos: getFeatureValue dentro
       del decisor dispara experiment_viewed en GrowthBook. */
    decidir();
    if (estado === true) {
      e.preventDefault();
      e.stopImmediatePropagation();
      /* Si la barra de chips de otra tarjeta quedó abierta, se cierra sola al
         tocar fuera (pcard-sizes.js); aquí no llega, así que se quita a mano. */
      document.querySelectorAll('.product-block--variants-open').forEach(function (b) { b.classList.remove('product-block--variants-open'); });
      if (abrirCajon(block, btn)) evento('quick_add_open');
      return;
    }
    if (estado === false) evento('quick_add_open');
  }, true);

  window.__ab2026_09 = {
    fijar: function (variante) { estado = variante === true; if (!estado) cerrarCajon(); },
    decisor: function (fn) { decisor = fn; },
    estado: function () { return estado; }
  };
})();
